var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlash = function SvgFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.633 1.92a.818.818 0 0 0-1.44-.626l-7.307 8.768c-.126.151-.254.304-.347.44-.088.127-.249.377-.254.707-.006.377.163.736.456.973.256.207.552.244.706.258.163.015.363.015.56.014h5.069l-.704 5.626a.818.818 0 0 0 1.44.626l7.307-8.767c.126-.152.254-.305.347-.44.088-.128.249-.378.254-.708a1.23 1.23 0 0 0-.456-.973c-.256-.207-.552-.244-.706-.258-.163-.015-.363-.015-.56-.015h-5.069z"
  })));
};
export default SvgFlash;